var _desc, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerbear(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.3.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.6226448787 0 0 1.6226448787 100 100)",
    id: "TuKpFHntTZ3E8Ea68DXuV"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.2511908417 0 0 2.1081147139 -2.0392949614 5.9199962858)",
    id: "z6bS8I9xUtd407_zxh8bw"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(13,235,204)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(154,112,65)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M 0 -20 C 11.04 -20 20 -11.04 20 0 C 20 11.04 11.04 20 0 20 C -11.04 20 -20 11.04 -20 0 C -20 -11.04 -11.04 -20 0 -20 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01875 0 0 1.01875 -37.1001306518 -27.7072905637)",
    id: "mSsuM1Fw_jmN8NHkft0U9"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(13,235,204)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(154,112,65)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M 0 -20 C 11.04 -20 20 -11.04 20 0 C 20 11.04 11.04 20 0 20 C -11.04 20 -20 11.04 -20 0 C -20 -11.04 -11.04 -20 0 -20 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01875 0 0 1.01875 37.1001306518 -27.7072905637)",
    id: "-qkeg9-SUn1gGT1_kBZRB"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(13,235,204)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(154,112,65)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M 0 -20 C 11.04 -20 20 -11.04 20 0 C 20 11.04 11.04 20 0 20 C -11.04 20 -20 11.04 -20 0 C -20 -11.04 -11.04 -20 0 -20 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.873501199 0 0 0.7505847202 -2.0392949614 24.160479786)",
    id: "SXEabfKE8uQVGUZxCj4w-"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(254,72,66)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,171,64)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M 0 -27.8 C 15.3456 -27.8 27.8 -15.345600000000001 27.8 0 C 27.8 15.3456 15.345600000000001 27.8 0 27.8 C -15.3456 27.8 -27.8 15.345600000000001 -27.8 0 C -27.8 -15.3456 -15.345600000000001 -27.8 0 -27.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.3315097922 0 0 0.3315097922 -3.4666963306 14.4726967865)",
    id: "vo73FNQVQ_tGiZX8aOuOu"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(254,72,66)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M 0 -27.8 C 15.3456 -27.8 27.8 -15.345600000000001 27.8 0 C 27.8 15.3456 15.345600000000001 27.8 0 27.8 C -15.3456 27.8 -27.8 15.345600000000001 -27.8 0 C -27.8 -15.3456 -15.345600000000001 -27.8 0 -27.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1387731843 0 0 0.2127606283 -20.5830251749 -5.7596037195)",
    id: "pYbhbeJuC4xjhmiuyLdaD"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(254,72,66)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M 0 -27.8 C 15.3456 -27.8 27.8 -15.345600000000001 27.8 0 C 27.8 15.3456 15.345600000000001 27.8 0 27.8 C -15.3456 27.8 -27.8 15.345600000000001 -27.8 0 C -27.8 -15.3456 -15.345600000000001 -27.8 0 -27.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1308841989 0 0 0.2006656008 13.0865499214 -5.4233619566)",
    id: "CtYLBzsWr_HNvufEHOuWT"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(254,72,66)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M 0 -27.8 C 15.3456 -27.8 27.8 -15.345600000000001 27.8 0 C 27.8 15.3456 15.345600000000001 27.8 0 27.8 C -15.3456 27.8 -27.8 15.345600000000001 -27.8 0 C -27.8 -15.3456 -15.345600000000001 -27.8 0 -27.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8130751038 0 0 0.6185039431 -21.5109039626 -5.4233619566)",
    id: "FDi--oLKda6Q9ZmGI2-ER"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1071",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -19 -19)",
    x1: 6.6675598428010225,
    y1: 4.368578669342873,
    x2: 26.35058131059941,
    y2: 21.29873229563796
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#F2FFF2",
      stopOpacity: 0.5098039215686274
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "47.53190122532172%",
    style: {
      stopColor: "#59758F",
      stopOpacity: 0.10196078431372549
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#233763",
      stopOpacity: 0.6
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,1,1)",
      strokeWidth: 2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_1071)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0.000005, 0)",
    d: "M -19 -10.93898 C -19 -15.39096 -16.25461 -19 -12.86801 -19 L 12.868 -19 L 12.868 -19 C 16.25461 -19 18.99999 -15.39096 18.99999 -10.93898 L 18.99999 10.93898 L 18.99999 10.93898 C 18.99999 15.39096 16.2546 19 12.868 19 L -12.86801 19 L -12.86801 19 C -16.25462 19 -19 15.39096 -19 10.93898 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8130751038 0 0 0.6185039431 14.4091279454 -5.4233596335)",
    id: "ryagqKRfn0r8UIeD21F4f"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1072",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 -19 -19)",
    x1: 6.6675598429606255,
    y1: 4.368578669153367,
    x2: 26.35058131123017,
    y2: 21.298732294714036
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#F2FFF2",
      stopOpacity: 0.5098039215686274
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "47.53190122532172%",
    style: {
      stopColor: "#59758F",
      stopOpacity: 0.10196078431372549
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#233763",
      stopOpacity: 0.6
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,1,1)",
      strokeWidth: 2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "url(#SVGID_1072)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0.000005, 0)",
    d: "M -19 -10.93898 C -19 -15.39096 -16.25461 -19 -12.86801 -19 L 12.868 -19 L 12.868 -19 C 16.25461 -19 18.99999 -15.39096 18.99999 -10.93898 L 18.99999 10.93898 L 18.99999 10.93898 C 18.99999 15.39096 16.2546 19 12.868 19 L -12.86801 19 L -12.86801 19 C -16.25462 19 -19 15.39096 -19 10.93898 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5028315958 -0.9390734053 0.0913935167 0.1462602006 4.3353666006 30.9702948102)",
    id: "dqbkOgbEvkGRQrQN7q66K"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,1,1)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0.000005)",
    d: "M -7.21646 -26.48856 C -7.21646 -26.48856 -3.9901099999999996 14.990569999999998 0.029190000000000715 14.990569999999998 C 4.0484800000000005 14.990569999999998 7.01409 -26.48856 7.01409 -26.48856 L 8.03858 -19.45481 C 8.03858 -19.45481 3.97598 26.48855 -0.04330999999999996 26.48855 C -4.0626 26.48855 -8.03858 -19.45481 -8.03858 -19.45481 z",
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerbear);
export default __webpack_public_path__ + "static/media/verbear.1f7ce46bafe5c4b2e05c324d9d39e9e0.svg";
export { ForwardRef as ReactComponent };